module.exports = __webpack_public_path__ + "static/media/ss14_preview.d34ce79a.jpg";